var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "presidentJudgmσentForm",
      attrs: { "label-width": "180px", disabled: _vm.isSaving },
      model: {
        value: _vm.presidentJudgement,
        callback: function($$v) {
          _vm.presidentJudgement = $$v
        },
        expression: "presidentJudgement"
      }
    },
    [
      !_vm.isReappraisal && this.workingApplication.grade
        ? _c(
            "el-form-item",
            {
              staticClass: "compact-form-item",
              attrs: { label: _vm.gradeLabel() }
            },
            [_vm._v("\n    " + _vm._s(this.workingApplication.grade) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isReappraisal && this.workingApplication.grade_description
        ? _c(
            "el-form-item",
            {
              staticClass: "compact-form-item",
              attrs: { label: _vm.gradeDescriptionLabel() }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(this.workingApplication.grade_description) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isReappraisal && this.workingApplication.certificationTitleByInternal
        ? _c(
            "el-form-item",
            {
              staticClass: "compact-form-item",
              attrs: { label: "Τίτλος Σπουδών" }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(this.workingApplication.certificationTitleByInternal) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      this.workingApplication.consideration &&
      this.workingApplication.considerationTitleByInternal
        ? _c(
            "el-form-item",
            {
              staticClass: "compact-form-item",
              attrs: { label: "Τίτλος Σπουδών (Συνυποβολή)" }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(this.workingApplication.considerationTitleByInternal) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isReappraisal && this.workingApplication.overdue
        ? _c(
            "el-form-item",
            [
              _c("el-alert", {
                staticStyle: {
                  border: "1px solid",
                  "background-color": "#fdf6ec"
                },
                attrs: {
                  closable: false,
                  type: "warning",
                  title: _vm.OVERDUE_MESSAGE,
                  "show-icon": ""
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isReappraisal
        ? _c(
            "el-form-item",
            { attrs: { label: "Κατηγορία αίτησης" } },
            [
              _c("el-switch", {
                attrs: {
                  disabled: "",
                  "active-text": "Νομικό ζήτημα",
                  "inactive-text": "Ακαδημαϊκό ζήτημα"
                },
                model: {
                  value: _vm.workingApplication.legalIssue,
                  callback: function($$v) {
                    _vm.$set(_vm.workingApplication, "legalIssue", $$v)
                  },
                  expression: "workingApplication.legalIssue"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.fromPrintDecision ? _c("internalComments") : _vm._e(),
      _vm._v(" "),
      _vm.fromProponent ||
      _vm.fromAcademicDirector ||
      _vm.fromBoard ||
      _vm.fromVice ||
      _vm.fromConsultant ||
      _vm.fromConsultantOverdue ||
      _vm.fromAcademicDirector2 ||
      _vm.fromSpecialReappraisalBoard ||
      _vm.evaluatorsToPay.length !== 0
        ? _c("proposals")
        : _vm._e(),
      _vm._v(" "),
      _vm.fromAcademicDirector
        ? _c(
            "el-form-item",
            { attrs: { label: "Εισήγηση Δ/ντή Αναγν/σης", size: "large" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  disabled: "",
                  autosize: { minRows: 2, maxRows: 4 }
                },
                model: {
                  value: _vm.academicDirectorJudgment.proposal,
                  callback: function($$v) {
                    _vm.$set(_vm.academicDirectorJudgment, "proposal", $$v)
                  },
                  expression: "academicDirectorJudgment.proposal"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fromAcademicDirector2
        ? _c(
            "el-form-item",
            { attrs: { label: "Αντισταθμιστικά μέτρα", size: "large" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  disabled: "",
                  autosize: { minRows: 2, maxRows: 4 }
                },
                model: {
                  value: _vm.academicDirectorJudgment.proposal,
                  callback: function($$v) {
                    _vm.$set(_vm.academicDirectorJudgment, "proposal", $$v)
                  },
                  expression: "academicDirectorJudgment.proposal"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fromViewer || _vm.fromSpecialReappraisalBoard
        ? _c(
            "div",
            [
              _vm.isReappraisal
                ? _c("hr", { staticStyle: { "margin-top": "20px" } })
                : _vm._e(),
              _vm._v(" "),
              _vm.isReappraisal
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Ενέργειες επανεξέτασης" } },
                    [
                      _vm.workingApplication.overdue
                        ? _c(
                            "el-form-item",
                            [
                              _c("el-checkbox", {
                                attrs: {
                                  label:
                                    "Αποδοχή εκπρόθεσμης αίτησης για επανεξέταση"
                                },
                                on: { change: _vm.toggleOverdue },
                                model: {
                                  value: _vm.presidentJudgement.acceptOverdue,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.presidentJudgement,
                                      "acceptOverdue",
                                      $$v
                                    )
                                  },
                                  expression: "presidentJudgement.acceptOverdue"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.workingApplication.overdue ||
                      _vm.presidentJudgement.acceptOverdue
                        ? _c(
                            "el-form-item",
                            [
                              _vm.isAvailableEmployeesLoaded
                                ? _c("reappraisal-board-selector", {
                                    attrs: {
                                      people: _vm.availableEmployees,
                                      "fixed-ids": _vm.fixedMembers,
                                      "initial-leader": _vm.leaderId,
                                      initialSelected: _vm.selectedEmployees
                                    },
                                    on: {
                                      "board-changed": _vm.handleBoardChange
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isReappraisal
                ? _c("hr", { staticStyle: { "margin-bottom": "20px" } })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fromPrechecker
        ? _c(
            "div",
            [
              _vm.isReappraisal
                ? _c("el-form-item", { attrs: { label: "Εκπρόθεσμη" } }, [
                    _vm._v(_vm._s(_vm.overdue))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isReappraisal
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Απόφαση Δ.Σ." } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 2,
                          placeholder: "Παρακαλώ εισάγετε την απόφαση του ΔΣ"
                        },
                        model: {
                          value: _vm.presidentJudgement.decisionOverdue,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.presidentJudgement,
                              "decisionOverdue",
                              $$v
                            )
                          },
                          expression: "presidentJudgement.decisionOverdue"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isReappraisal && this.workingApplication.overdue
                ? _c(
                    "el-form-item",
                    [
                      _c("el-checkbox", {
                        attrs: { label: "Αποδοχή εκπρόθεσμης αίτησης" },
                        on: { change: _vm.toggleOverdue },
                        model: {
                          value: _vm.presidentJudgement.acceptOverdue,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.presidentJudgement,
                              "acceptOverdue",
                              $$v
                            )
                          },
                          expression: "presidentJudgement.acceptOverdue"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isReappraisal
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Προτεινόμενη Ακαδ.Περιοχή" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "", size: "large" },
                        model: {
                          value: _vm.precheckerJudgement.academicField.name,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.precheckerJudgement.academicField,
                              "name",
                              $$v
                            )
                          },
                          expression: "precheckerJudgement.academicField.name"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isReappraisal
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Ακαδημαϊκη Περιοχή" } },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.workingApplication.relevantAppl.academicField
                              .name
                          ) +
                          "\n    "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isReappraisal
                ? _c(
                    "el-form-item",
                    { attrs: { size: "large" } },
                    [
                      _c("el-checkbox", {
                        attrs: { label: "Αποδοχή Προτ.Ακαδημαϊκής Περιοχής" },
                        on: { change: _vm.toggleChecked },
                        model: {
                          value: _vm.checked,
                          callback: function($$v) {
                            _vm.checked = $$v
                          },
                          expression: "checked"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isReappraisal && _vm.checked === false
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Ορισμός νέας Ακαδημαϊκής Περιοχής",
                        size: "large"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "bigger",
                          attrs: {
                            filterable: "",
                            placeholder: "Ακαδημαϊκή Περιοχή"
                          },
                          on: { change: _vm.toggleAcademicField },
                          model: {
                            value: _vm.presidentJudgement.academicField.name,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.presidentJudgement.academicField,
                                "name",
                                $$v
                              )
                            },
                            expression: "presidentJudgement.academicField.name"
                          }
                        },
                        _vm._l(_vm.academicAreas, function(area) {
                          return _c("el-option", {
                            key: area.id,
                            attrs: {
                              value: area.id,
                              label: area.name,
                              filterable: ""
                            }
                          })
                        })
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isReappraisal &&
              !_vm.isSecondReappraisal &&
              _vm.presidentJudgement.acceptOverdue
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Ανάθεση σε Αντιπρόεδρο" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "Παρακαλώ Επιλέξτε" },
                          model: {
                            value: _vm.presidentJudgement.assignedTo.role,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.presidentJudgement.assignedTo,
                                "role",
                                $$v
                              )
                            },
                            expression: "presidentJudgement.assignedTo.role"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: "Αντιπρόεδρος Α",
                              value: "VicePresidentA"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: {
                              label: "Αντιπρόεδρος Β",
                              value: "VicePresidentB"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fromBoard
        ? _c(
            "div",
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.judgementFromBoardMembers }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "Όνομα", width: "140" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.firstname))])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Επώνυμο", width: "140" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.surname))])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _vm.isReappraisal
                    ? _c("el-table-column", {
                        attrs: { label: "Πλήρης αποδοχή επανεξ." },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.fullyAgreeWithReappraisal
                                  ? _c("el-button", {
                                      attrs: {
                                        type: "success",
                                        icon: "el-icon-check",
                                        circle: ""
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !scope.row.fullyAgreeWithReappraisal
                                  ? _c("el-button", {
                                      attrs: {
                                        type: "danger",
                                        icon: "el-icon-close",
                                        circle: ""
                                      }
                                    })
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isReappraisal
                    ? _c(
                        "el-table-column",
                        { attrs: { label: "Αποδοχή πρότασης", width: "205" } },
                        [
                          _c("el-table-column", {
                            attrs: { label: "Χειριστή", width: "95" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.agreeWithProponent
                                      ? _c("el-button", {
                                          attrs: {
                                            type: "success",
                                            icon: "el-icon-check",
                                            circle: ""
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.agreeWithProponent === false
                                      ? _c("el-button", {
                                          attrs: {
                                            type: "danger",
                                            icon: "el-icon-close",
                                            circle: ""
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _vm.fromConsultant
                            ? _c("el-table-column", {
                                attrs: {
                                  label: "Ακαδημαϊκού Συμβούλου",
                                  width: "110"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        scope.row.agreeWithAC
                                          ? _c("el-button", {
                                              attrs: {
                                                type: "success",
                                                icon: "el-icon-check",
                                                circle: ""
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.agreeWithAC === false
                                          ? _c("el-button", {
                                              attrs: {
                                                type: "danger",
                                                icon: "el-icon-close",
                                                circle: ""
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ])
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Εισήγηση" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.proposal))])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Σχόλιο" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.comment))])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("hr")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fromVice
        ? _c(
            "div",
            [
              _c("h4", [_vm._v("Απόφαση Συνεδρίασης Τμήματος:")]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { type: "textarea", disabled: "", size: "large" },
                model: {
                  value: _vm.judgementFromVice.comment,
                  callback: function($$v) {
                    _vm.$set(_vm.judgementFromVice, "comment", $$v)
                  },
                  expression: "judgementFromVice.comment"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showDecision
        ? _c("president-decision", {
            attrs: {
              validatedFinalDecisions: _vm.validatedFinalDecisions,
              presidentJudgement: _vm.presidentJudgement,
              titlesCorrespondence: _vm.titlesCorrespondence,
              fromConsultant: _vm.fromConsultant,
              fromConsultant2: _vm.fromConsultant2,
              fromConsultantOverdue: _vm.fromConsultantOverdue,
              fromBoard: _vm.fromBoard,
              fromProponent: _vm.fromProponent,
              fromAcademicDirector: _vm.fromAcademicDirector,
              fromVice: _vm.fromVice,
              fromViceThroughBoard: _vm.fromViceThroughBoard,
              fromViceThroughReappraisalBoard:
                _vm.fromViceThroughReappraisalBoard,
              fromAcademicDirector2: _vm.fromAcademicDirector2,
              fromAcademicDirectorReappraisal:
                _vm.fromAcademicDirectorReappraisal,
              reappDegreeType: _vm.reappDegreeType,
              reappraise: _vm.reappraise,
              isPostExam: _vm.isPostExam,
              isSecondReappraisal: _vm.isSecondReappraisal
            },
            on: {
              changedPresidentDecision: _vm.changedPresidentDecisionEvent,
              changedPresidentReappraisalDecision:
                _vm.changedPresidentReappraisalDecisionEvent,
              changedVice: _vm.changedViceEvent
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.presidentJudgement.decision_type === "Παραπομπή σε Αξιολογητή"
        ? _c(
            "el-form-item",
            { attrs: { label: "Επιλογή αξιολογητή" } },
            [
              _c(
                "el-select",
                {
                  attrs: { filterable: "" },
                  model: {
                    value: _vm.presidentJudgement.assignedTo.uid,
                    callback: function($$v) {
                      _vm.$set(_vm.presidentJudgement.assignedTo, "uid", $$v)
                    },
                    expression: "presidentJudgement.assignedTo.uid"
                  }
                },
                _vm._l(_vm.usersToAssign, function(user) {
                  return _c("el-option", {
                    key: user.id,
                    attrs: {
                      value: user.id,
                      label:
                        user.surname +
                        " " +
                        user.firstname +
                        " - " +
                        user.specialty.name
                    }
                  })
                })
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fromPrintDecision
        ? _c(
            "div",
            [
              _c(
                "el-form-item",
                { attrs: { label: "Σχόλιο Καταχωρητή" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", disabled: "", size: "large" },
                    model: {
                      value: _vm.judgementFromPrintDecision.comment,
                      callback: function($$v) {
                        _vm.$set(_vm.judgementFromPrintDecision, "comment", $$v)
                      },
                      expression: "judgementFromPrintDecision.comment"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.evaluatorsToPay.length !== 0
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "short-line-height",
                      attrs: { label: "Αξιολογητές προς αποζημίωση" }
                    },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          on: { change: _vm.checkedEvaluatorsChanged },
                          model: {
                            value: _vm.checkedEvaluators,
                            callback: function($$v) {
                              _vm.checkedEvaluators = $$v
                            },
                            expression: "checkedEvaluators"
                          }
                        },
                        _vm._l(_vm.evaluatorsToPay, function(evaluator) {
                          return _c(
                            "el-checkbox",
                            {
                              key: evaluator.id,
                              staticClass:
                                "el-checkbox__wrapped short-line-height",
                              attrs: {
                                label: evaluator.id,
                                checked: evaluator.id === _vm.lastEvaluator.id
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(evaluator.surname + " " + evaluator.name)
                              )
                            ]
                          )
                        })
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.workingApplication.usersAllApplications !== []
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Προηγούμενες αιτήσεις" } },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "80%" },
                          attrs: { data: _vm.tableData }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "expand" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(props) {
                                  return [
                                    _c("p", [
                                      _vm._v(
                                        "Πρωτόκολλο: " +
                                          _vm._s(props.row.protocol)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "Ημερομηνία πρωτοκόλλου: " +
                                          _vm._s(props.row.protocol_date)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "Id αίτησης: " + _vm._s(props.row.id)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function($event) {
                                            _vm.loadPreviousApp(props.row.id)
                                          }
                                        }
                                      },
                                      [_vm._v("Προβολή")]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "Τύπος αίτησης",
                              prop: "grApplicationType"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "Κατάσταση",
                              prop: "applicationStatus"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showPreviousApp
                ? _c(
                    "el-dialog",
                    {
                      attrs: { visible: _vm.showPreviousApp, width: "90%" },
                      on: {
                        "update:visible": function($event) {
                          _vm.showPreviousApp = $event
                        }
                      }
                    },
                    [
                      _c(
                        "el-card",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loadingSearchedApplication,
                              expression: "loadingSearchedApplication"
                            }
                          ],
                          staticClass: "box-card bg-purple"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "text item" },
                            [
                              _vm.showSearchedApplication
                                ? _c(
                                    "el-tabs",
                                    {
                                      attrs: { stretch: true },
                                      model: {
                                        value: _vm.activeName,
                                        callback: function($$v) {
                                          _vm.activeName = $$v
                                        },
                                        expression: "activeName"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-tab-pane",
                                        {
                                          attrs: {
                                            label: "Προσωπικά Στοιχεία",
                                            name: "first"
                                          }
                                        },
                                        [
                                          _c("personal-details", {
                                            attrs: {
                                              personalDetails:
                                                _vm.searchedApplication
                                                  .personalDetails
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.searchedApplication
                                        .applicationType !== "reappraisal" &&
                                      _vm.searchedApplication
                                        .applicationType !== "compensatory"
                                        ? _c(
                                            "el-tab-pane",
                                            {
                                              attrs: {
                                                label: "Τίτλος Σπουδών",
                                                name: "second"
                                              }
                                            },
                                            [
                                              _c("titles", {
                                                attrs: {
                                                  application:
                                                    _vm.searchedApplication
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.searchedApplication.degreeType ===
                                        "bachelor" &&
                                      _vm.searchedApplication.consideration ===
                                        true &&
                                      _vm.searchedApplication
                                        .applicationType !== "reappraisal"
                                        ? _c(
                                            "el-tab-pane",
                                            {
                                              attrs: {
                                                label: "Συνυποβολή Τίτλου",
                                                name: "third"
                                              }
                                            },
                                            [
                                              _c("title-consideration", {
                                                attrs: {
                                                  application:
                                                    _vm.searchedApplication
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "el-tab-pane",
                                        {
                                          attrs: {
                                            label: "Επισυναπτόμενα",
                                            name: "fourth"
                                          }
                                        },
                                        [
                                          _c("attached-documents", {
                                            attrs: {
                                              userComment:
                                                _vm.searchedApplication
                                                  .userComment,
                                              attachedDocumentsTable:
                                                _vm.attachedDocumentsTable,
                                              appId: _vm.searchedApplication.id,
                                              role: _vm.role,
                                              neededDocuments:
                                                _vm.searchedApplication
                                                  .neededDocuments
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-tab-pane",
                                        {
                                          attrs: {
                                            label: "Ιστορικό",
                                            name: "fifth",
                                            lazy: true
                                          }
                                        },
                                        [
                                          _c("history-line", {
                                            attrs: {
                                              applicationHistory:
                                                _vm.searchedAppHistory
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.searchedApplication
                                        .applicationType === "reappraisal" ||
                                      _vm.searchedApplication
                                        .applicationType === "compensatory"
                                        ? _c(
                                            "el-tab-pane",
                                            {
                                              attrs: {
                                                label: "Σχετική αίτηση",
                                                name: "seventh",
                                                lazy: true
                                              }
                                            },
                                            [
                                              _c("relevant-app", {
                                                attrs: {
                                                  relevantApp:
                                                    _vm.searchedApplication
                                                      .relevantApplication
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("document-signing", {
                attrs: {
                  url: _vm.signUrl,
                  config: _vm.signingConfiguration,
                  data: { ac_iDs: _vm.checkedEvaluators }
                },
                on: {
                  "signed-successfully": _vm.documentSignedSuccessfully,
                  "signing-error": _vm.documentSignError
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.fromPrintDecision && !_vm.fromAcademicDirectorReappraisal
        ? _c(
            "div",
            [
              _c(
                "el-form-item",
                { attrs: { label: "Εσωτερικό Σχόλιο", size: "large" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 4 },
                      placeholder: "Εισάγετε το σχόλιό σας"
                    },
                    model: {
                      value: _vm.internalComment,
                      callback: function($$v) {
                        _vm.internalComment = $$v
                      },
                      expression: "internalComment"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.fromSpecialReappraisalBoard
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Σχόλιο επιστροφής", size: "large" } },
                    [
                      _c("el-input", {
                        staticClass: "return-comment",
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 3, maxRows: 4 },
                          placeholder:
                            "Σχόλιο επιστροφής της αίτησης στον Πρόεδρο (υποχρεωτικό)",
                          disabled: ""
                        },
                        model: {
                          value: _vm.returnComment,
                          callback: function($$v) {
                            _vm.returnComment = $$v
                          },
                          expression: "returnComment"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Στην Αναμονή" } },
                [
                  _c("el-checkbox", {
                    attrs: { label: "Ναι", border: "" },
                    on: { change: _vm.toggleQueue },
                    model: {
                      value: _vm.presidentJudgement.queue,
                      callback: function($$v) {
                        _vm.$set(_vm.presidentJudgement, "queue", $$v)
                      },
                      expression: "presidentJudgement.queue"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Χρώμα" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Εισάγετε χρώμα" },
                    model: {
                      value: _vm.presidentJudgement.color,
                      callback: function($$v) {
                        _vm.$set(_vm.presidentJudgement, "color", $$v)
                      },
                      expression: "presidentJudgement.color"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      (!_vm.reappraise && !_vm.isPostExam) ||
      (_vm.isPostExam && _vm.fromViewer) ||
      (_vm.reappraise && (_vm.fromViewer || _vm.fromSpecialReappraisalBoard))
        ? _c(
            "div",
            [
              _c(
                "el-form-item",
                [
                  _c("el-checkbox", {
                    attrs: { label: "Επιθυμώ να αποδεσμεύσω την αίτηση" },
                    model: {
                      value: _vm.releaseChecked,
                      callback: function($$v) {
                        _vm.releaseChecked = $$v
                      },
                      expression: "releaseChecked"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("hr")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        [
          (!_vm.reappraise && !_vm.fromPrintDecision) ||
          (_vm.reappraise &&
            (_vm.fromViewer || _vm.fromSpecialReappraisalBoard))
            ? _c("releaseButton", {
                attrs: {
                  releaseOrReroute: "release",
                  popoverContent:
                    "Είστε σίγουροι ότι θέλετε να την αποδεσμεύσετε στον προέλεγχο;\n        Αν ναι το σχόλιο για τον λόγο της αποδέσμευσης είναι υποχρεωτικό!",
                  tooltipContent: "Η αίτηση θα επιστρέψει στον προέλεγχο",
                  releaseChecked: _vm.releaseChecked,
                  workingApplicationId: _vm.workingApplication.id,
                  releaseByUser: "president"
                },
                on: { releasedDoc: _vm.releaseOk }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.reappraise && !_vm.isPostExam
            ? _c("releaseButton", {
                attrs: {
                  releaseOrReroute: "reroute",
                  popoverContent:
                    "Είστε σίγουροι ότι θέλετε να την αποδεσμεύσετε στον Χειριστή;\n        Αν ναι το σχόλιο για τον λόγο της αποδέσμευσης είναι υποχρεωτικό!",
                  tooltipContent: "Η αίτηση θα επιστρέψει στον Χειριστή",
                  releaseChecked: _vm.releaseChecked && _vm.hasProponent,
                  workingApplicationId: _vm.workingApplication.id,
                  releaseByUser: "president"
                },
                on: { releasedDoc: _vm.releaseOk }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.fromPrintDecision && !_vm.fromAcademicDirectorReappraisal
            ? _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: "primary",
                    round: "",
                    disabled: false
                  },
                  on: { click: _vm.tempSave }
                },
                [_vm._v("\n      Προσωρινή Αποθήκευση\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.fromPrintDecision
            ? _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    round: "",
                    type: "primary",
                    disabled: _vm.isDisabled
                  },
                  on: { click: _vm.finalSave }
                },
                [_vm._v("\n      Οριστική Υποβολή\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e4238ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e4238ee","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/PresidentJudgement.vue
// module id = null
// module chunks = 